/* eslint-disable */
import {
  ADMIN_USER_ROLE_GET_STATUS_COUNT,
  ADMIN_USER_ROLE_GET_STATUS_COUNT_SUCCESS,
  ADMIN_USER_ROLE_GET_STATUS_COUNT_FAILURE,
  ADMIN_USER_ROLE_ADD_USER,
  ADMIN_USER_ROLE_ADD_USER_SUCCESS,
  ADMIN_USER_ROLE_ADD_USER_FAILURE,
  ADMIN_USER_ROLE_UPDATE_FILTER,
  ADMIN_USER_ROLE_SET_ACTIVE_STATUS,
  ADMIN_USER_ROLE_TOGGLE_ADD_USER_DRAWER,
  ADMIN_USER_ROLE_CLEAR_USER_FORM,
  ADMIN_USER_ROLE_GET_ROLES,
  ADMIN_USER_ROLE_GET_ROLES_SUCCESS,
  ADMIN_USER_ROLE_GET_ROLES_FAILURE,
  ADMIN_USER_ROLE_GET_ROLES_LIST,
  ADMIN_USER_ROLE_GET_ROLES_LIST_SUCCESS,
  ADMIN_USER_ROLE_GET_ROLES_LIST_FAILURE,
  ADMIN_USER_ROLE_INCREMENT_CLEAR_SELECTION,
  ADMIN_USER_ROLE_SET_SELECTED_CLIENT,
  ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT,
  ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT_SUCCESS,
  ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT_FAILURE,
} from './constants';

const initialState = {
  isLoading: false,
  error: null,
  statusCounts: {
    totalUsers: 0,
    needApproval: 0
  },
  filters: {
    search: '',
    status: null,
    primaryRoles: [],
    editableSites: [],
    readOnlySites: []
  },
  activeStatus: "all",
  drawerOpen: false,
  addUserForm: {
    firstName: '',
    lastName: '',
    email: '',
    role: '',
    siteAccess: []
  },
  addUserMode: 'add',
  selectedRows: [],
  addUserSuccess: 0,
  clearSelectionCount: 0,
  roles: [],
  rolesLoading: false,
  rolesList: [],
  rolesListLoading: false,
  rolesListError: null,
  selectedClient: null,
  selectedClientLoading: false,
  selectedClientError: null
};

const adminUserRoleReducer = (state = initialState, action) => {
  switch (action.type) {
    // Status count actions
    case ADMIN_USER_ROLE_GET_STATUS_COUNT:
      return {
        ...state,
        isLoading: true
      };
      
    case ADMIN_USER_ROLE_GET_STATUS_COUNT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        statusCounts: {
          totalUsers: action.payload.totalUsers,
          needApproval: action.payload.needApproval
        }
      };
      
    case ADMIN_USER_ROLE_GET_STATUS_COUNT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
      
    // Add user actions
    case ADMIN_USER_ROLE_ADD_USER:
      return {
        ...state,
        isLoading: true
      };
      
    case ADMIN_USER_ROLE_ADD_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        addUserSuccess: state.addUserSuccess + 1,
        addUserForm: initialState.addUserForm
      };
      
    case ADMIN_USER_ROLE_ADD_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
      
    // Filter actions
    case ADMIN_USER_ROLE_UPDATE_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload
        }
      };
      
    // Set active status
    case ADMIN_USER_ROLE_SET_ACTIVE_STATUS:
      return {
        ...state,
        activeStatus: action.payload
      };
      
    // Toggle drawer
    case ADMIN_USER_ROLE_TOGGLE_ADD_USER_DRAWER:
      return {
        ...state,
        drawerOpen: action.payload?.isOpen !== undefined ? action.payload.isOpen : !state.drawerOpen,
        addUserMode: action.payload?.mode || 'add',
        selectedRows: action.payload?.selectedRows || [],
      };
      
    // Clear user form
    case ADMIN_USER_ROLE_CLEAR_USER_FORM:
      return {
        ...state,
        addUserForm: initialState.addUserForm,
        selectedRows: [],
        addUserMode: 'add'
        
      };
      
    // Get roles actions
    case ADMIN_USER_ROLE_GET_ROLES:
      return {
        ...state,
        rolesLoading: true
      };
      
    case ADMIN_USER_ROLE_GET_ROLES_SUCCESS:
      return {
        ...state,
        rolesLoading: false,
        roles: action.payload
      };
      
    case ADMIN_USER_ROLE_GET_ROLES_FAILURE:
      return {
        ...state,
        rolesLoading: false,
        error: action.payload
      };
    
    // Get roles list actions
    case ADMIN_USER_ROLE_GET_ROLES_LIST:
      return {
        ...state,
        rolesListLoading: true,
        rolesListError: null
      };
      
    case ADMIN_USER_ROLE_GET_ROLES_LIST_SUCCESS:
      return {
        ...state,
        rolesListLoading: false,
        rolesList: action.payload,
        rolesListError: null
      };
      
    case ADMIN_USER_ROLE_GET_ROLES_LIST_FAILURE:
      return {
        ...state,
        rolesListLoading: false,
        rolesListError: action.payload
      };
    
    // Increment clear selection count
    case ADMIN_USER_ROLE_INCREMENT_CLEAR_SELECTION:
      return {
        ...state,
        clearSelectionCount: state.clearSelectionCount + 1
      };
    
    // Set selected client
    case ADMIN_USER_ROLE_SET_SELECTED_CLIENT:
      return {
        ...state,
        selectedClient: action.payload
      };
    
    // Update selected client
    case ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT:
      return {
        ...state,
        selectedClientLoading: true,
        selectedClientError: null
      };
    
    case ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT_SUCCESS:
      return {
        ...state,
        selectedClientLoading: false,
        selectedClientError: null
      };
    
    case ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT_FAILURE:
      return {
        ...state,
        selectedClientLoading: false,
        selectedClientError: action.payload
      };
      
    default:
      return state;
  }
};

export default adminUserRoleReducer;
